import { inventoryMovementApi } from '../../api';
import { InventoryMovementFilter } from '../../types/inventory/InventoryMovementTypes';

const InventoryMovementService = {
  /**
   * Obtiene una lista paginada de movimientos de inventario filtrados.
   * POST /api/inventory/movements/filtered?page=X&size=Y
   */
  getFiltered: async (
    filter: InventoryMovementFilter,
    page = 0,
    size = 10,
    sort = 'movementDate,desc' // 🔥 Por defecto los más recientes primero
  ) => {
    const response = await inventoryMovementApi.addCustom(
      `/filtered?page=${page}&size=${size}&sort=${sort}`,
      filter
    );
    return response.data;
  }
};

export default InventoryMovementService;
